import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class GetUserAlertsService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Fetcher} deps.repository
   * @param {Object} deps.getCurrentUserService
   * @param {Object} deps.getUserNotLoggedInUserError
   */
  constructor({repository, getCurrentUserService, getUserNotLoggedInUserError}) {
    super({
      repository,
      getCurrentUserService,
      getUserNotLoggedInUserError
    })

    this._repository = repository
    this._getCurrentUserService = getCurrentUserService
    this._getUserNotLoggedInUserError = getUserNotLoggedInUserError
  }

  _throwGetUserNotLoggedInUserError(message) {
    throw this._getUserNotLoggedInUserError({
      message: `[GetUserAlertsService#get] ${message}}`
    })
  }

  /**
   * @return {Promise<Object, Error>} returns current logged user
   * @property {Object} user
   */

  _getUserId = async () => {
    const currentUser = await this._getCurrentUserService.execute()
    return currentUser
      ? currentUser.getId()
      : this._throwGetUserNotLoggedInUserError('[GetUserAlertsService#execute] Unknown user ID')
  }

  /**
   * @return {Promise<Object, Error>} returns current user alerts
   * @property {UserAlertsListValueObject} userAlertsListValueObject
   * **/

  @inlineError
  async execute() {
    const userId = await this._getUserId()
    const [error, alerts] = await this._repository.getUserAlerts({
      userId
    })
    if (error) return Promise.reject(error)

    return alerts
  }
}
